import React, { useState } from 'react';
import styled from 'styled-components';
import { Border, Breakpoints, Color, Grid, Shadow, Type } from '../../../app/StyleGuide';

export const TabContainer = styled.ul`
  display: flex;
  padding: 0;
  margin: 0;
  box-shadow: 0 0 0 1px ${Color.Blue._15}, ${Shadow.regular};
  overflow-x: auto;
  white-space: nowrap;
  margin-top: ${Grid._6};
  border-radius: ${Border.radius} ${Border.radius} 0 0;
`;

export const Tab = styled.li<{ isActive: boolean }>`
  list-style-type: none;
  text-align: center;
  background-color: ${props => (props.isActive ? 'white' : `${Color.Gray._05}`)};
  border-right: 1px solid ${Color.Blue._15};
  border-bottom: ${props => (props.isActive ? 'none' : `1px solid ${Color.Blue._15}`)};
  color: ${props => (props.isActive ? `${Type.Color.dark}` : `${Type.Color.medium}`)};
  cursor: pointer;
  font-size: ${Type.Scale._3};
`;

export const TabButton = styled.button`
  padding: ${Grid._4} ${Grid._7};
  border: 0;
  font-weight: ${Type.Weight.semibold};
  background: transparent;

  span {
    display: none;
    @media screen and (min-width: ${Breakpoints.screen_sm}) {
      display: inline-block;
      opacity: 0.6;
      color: ${Type.Color.medium};
      font-size: ${Type.Scale._2};
      position: relative;
      top: -1px;
    }
  }
`;

const ContentContainer = styled.div`
  padding: ${Grid._7};
  background: white;
  box-shadow: 0 0 0 1px ${Color.Blue._15}, ${Shadow.regular};
  border-radius: 0 0 ${Border.radius} ${Border.radius};

  @media screen and (max-width: ${Breakpoints.screen_sm}) {
    padding: ${Grid._5} 0;
  }
`;

type TabId = 'pathways' | 'courses' | 'content';
type TabLabel = 'Pathways' | 'Courses' | 'Content';

type Props = {
  items: Array<{ id: TabId; label: TabLabel }>;
  handleTabClick: (id: TabId) => void;
  defaultActiveTab: TabId;
  children: React.ReactNode;
};

export const TabbedContainer = ({ items, handleTabClick, defaultActiveTab, children }: Props) => {
  const [activeTabId, setActiveTabId] = useState(defaultActiveTab);

  const handleClick = (id: TabId) => {
    setActiveTabId(id);
    handleTabClick(id);
  };

  return (
    <>
      <TabContainer>
        {items.map(tab => (
          <Tab key={tab.id} isActive={activeTabId === tab.id}>
            <TabButton onClick={() => handleClick(tab.id)}>{tab.label}</TabButton>
          </Tab>
        ))}
      </TabContainer>
      <ContentContainer>{children}</ContentContainer>
    </>
  );
};
